import {
  postMessage,
  postScrollMessage,
  postHeaderMessage,
  postCollectionsMessage,
  postFeaturedCollectionMessage,
  postSiteMapsMessage
} from '@/server/site-editor'

// ------------- mock 数据 上线要删除 ----------------
const ins = {
  sectionId: '11',
  sectionDomId: 'ins1614671992163',
  sectionType: 'ins',
  sectionIcon: 'iconimage',
  sectionName: 'ins精选集',
  data: {
    title: 'Find us on Instagram',
    cards: [
        {
        id: 1614677792329,
        imgUrl: '',
        imgAlt: '',
        actionUrl: '',
        profilePhoto: '',
        profilePhotoAlt: '',
        userName: 'username',
        accountId: 'account_id'
        },
        {
        id: 1614677792328,
        imgUrl: '',
        imgAlt: '',
        actionUrl: '',
        profilePhoto: '',
        profilePhotoAlt: '',
        userName: 'username',
        accountId: 'account_id'
        },
        {
        id: 1614677792327,
        imgUrl: '',
        imgAlt: '',
        actionUrl: '',
        profilePhoto: '',
        profilePhotoAlt: '',
        userName: 'username',
        accountId: 'account_id'
        },
        {
        id: 1614677792326,
        imgUrl: '',
        imgAlt: '',
        actionUrl: '',
        profilePhoto: '',
        profilePhotoAlt: '',
        userName: 'username',
        accountId: 'account_id'
        },
        {
        id: 1614677792325,
        imgUrl: '',
        imgAlt: '',
        actionUrl: '',
        profilePhoto: '',
        profilePhotoAlt: '',
        userName: 'username',
        accountId: 'account_id'
        },
        {
        id: 1614677792324,
        imgUrl: '',
        imgAlt: '',
        actionUrl: '',
        profilePhoto: '',
        profilePhotoAlt: '',
        userName: 'username',
        accountId: 'account_id'
        }
      ]
    }
  }
const threePic = {
  sectionId: '12',
  sectionDomId: 'threePic1614671992163',
  sectionType: 'threePic',
  sectionIcon: 'iconimage',
  sectionName: '图集(3图)',
  data: {
    style: '1',
    image1: {
      index: '1',
      imgUrl: '',
      imgAlt: '',
      actionUrl: ''
    },
    image2: {
      index: '2',
      imgUrl: '',
      imgAlt: '',
      actionUrl: ''
    },
    image3: {
      index: '3',
      imgUrl: '',
      imgAlt: '',
      actionUrl: ''
    },
  }
}
const imageText = {
  sectionId: '13',
  sectionDomId: 'imageText1614671992163',
  sectionType: 'imageText',
  sectionIcon: 'iconimage',
  sectionName: '图文',
  data: {
    style: '1',
    imgUrl: '',
    imgAlt: '',
    title: 'Image with text',
    content: 'A detailed description of the picture, such as a product series or a detailed description of the product',
    textAlign: 'LEFT',
    btnTitle: 'shop now',
    btnUrl: ''
  }
}
// ------------- mock 数据 上线要删除 ----------------

export default {
  state: {
    current: 'section', // 具体枚举含义见：views/site-edit/config/section-config。js
    assideHeight: '',
    isEdited: false, // 是否编辑过
    themeDto: null,
    IFRAME: null,
    previewMode: '1', // 预览模式，1：PC端，2:移动端，3:全屏模式
    tmpData: {
      type: 1,
      name: '',
      config: '',
      isPublish: 2,
      shopId: '',
      themeId: '',
      id: ''
    },
    sectionsData: {},
    basicConfig: { // 站点基础配置，对应“格式”界面
      favicon: '',
      faviconAlt: '',
      logoUrl: '',
      logoAlt: ''
    },
    siteMaps: []
  },
  mutations: {
    resetStore(state) {
      state.current = 'section'
      state.isEdited = false
    },
    setAssideHeight(state, assideHeight) {
      state.assideHeight = assideHeight
    },
    setCurrent(state, current) {
      state.current = current
      postScrollMessage(state.IFRAME, { isScroll: true, currentDomId: current })
    },
    setIsEdited(state, isEdited) {
      state.isEdited = isEdited
    },
    setPreviewMode(state, mode) {
      state.previewMode = mode
      // postMessage(state.IFRAME, { reload: true })
    },
    initTmpData(state, data) {
      state.tmpData = { ...state.tmpData, ...data }
    },
    initSectionsData(state, data) {
      // ------------- mock 数据 上线要恢复 ----------------
      state.sectionsData = { ...state.sectionsData, ...data }
      // ------------- mock 数据 上线要恢复 ----------------
    },
    addSection(state, payload) {
      state.sectionsData[payload.sectionDomId] = payload.data
    },
    delSection(state, payload) {
      delete state.sectionsData[payload.sectionDomId]
    },
    initThemeDto(state, data) {
      state.themeDto = data
    },
    initIFRAME(state, data) {
      state.IFRAME = data
    },
    initBasicConfig(state, data) {
      if (!data) return
      state.basicConfig = data
    },
    // --------- header section ---------
    setSHeaderByKey(state, payload) {
      state.sectionsData[payload.sDomId].data[payload.key] = payload.value
      postHeaderMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    setSHeaderAddNoticeItem(state, payload) {
      state.sectionsData[payload.sDomId].data.notice['contentArr'].push(payload.value)
      postHeaderMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    setSHeaderNoticeArrContent(state, payload) {
      state.sectionsData[payload.sDomId].data.notice.contentArr[payload.index].content = payload.value
      postHeaderMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    setSHeaderNoticeArrUrl(state, payload) {
      state.sectionsData[payload.sDomId].data.notice.contentArr[payload.index].url = payload.value
      postHeaderMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    setSHeaderNoticeArrName(state, payload) {
      state.sectionsData[payload.sDomId].data.notice.contentArr[payload.index].name = payload.value
      postHeaderMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    setSHeaderNoticeItemDel(state, payload) {
      state.sectionsData[payload.sDomId].data.notice.contentArr.splice(payload.index, 1)
      postHeaderMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    // --------- banner section ---------
    setBannerByKey(state, payload) {
      state.sectionsData[payload.sDomId].data[payload.key] = payload.value
      postMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    // --------- slidesshow section ---------
    setSSlidesshowItems(state, payload) {
      state.sectionsData[payload.sDomId].data.items = payload.value
      postMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    delSSlidesshowItem(state, payload) {
      state.sectionsData[payload.sDomId].data.items.splice(payload.index, 1)
      postMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    addSSlidesshowItem(state, payload) {
      let defaultItem = {
        id: Date.now(),
        actionUrl: '',
        imgAlt: '',
        imgUrl: '',
        imgAltMobile: '',
        imgUrlMobile: ''
      }
      state.sectionsData[payload.sDomId].data.items.push(defaultItem)
      postMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    setSSlidesshowByIndexKey(state, payload) {
      state.sectionsData[payload.sDomId].data.items[payload.index][payload.key] = payload.value
      postMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    // setSSlidesshowActionurl(state, payload) {
    //   state.sectionsData[payload.sDomId].data.items[payload.index].actionUrl = payload.value
    //   postMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    // },
    // setSSlidesshowActionname(state, payload) {
    //   state.sectionsData[payload.sDomId].data.items[payload.index].actionName = payload.value
    //   postMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    // },
    // setSSlidesshowImgurl(state, payload) {
    //   state.sectionsData[payload.sDomId].data.items[payload.index].imgUrl = payload.value
    //   postMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    // },
    // setSSlidesshowImgalt(state, payload) {
    //   state.sectionsData[payload.sDomId].data.items[payload.index].imgAlt = payload.value
    //   postMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    // },
    // setSSlidesshowImgurlMobile(state, payload) {
    //   state.sectionsData[payload.sDomId].data.items[payload.index].imgUrlMobile = payload.value
    //   postMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    // },
    // setSSlidesshowImgaltMobile(state, payload) {
    //   state.sectionsData[payload.sDomId].data.items[payload.index].imgAltMobile = payload.value
    //   postMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    // },
    // --------- collections section ---------
    setSCollectionsItemByKey(state, payload) {
      state.sectionsData[payload.sDomId].data.items[payload.index][payload.key] = payload.value
      postCollectionsMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    // setSCollectionsId(state, payload) {
    //   state.sectionsData[payload.sDomId].data.items[payload.index].collectionId = payload.value
    //   postCollectionsMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    // },
    // setSCollectionsName(state, payload) {
    //   state.sectionsData[payload.sDomId].data.items[payload.index].collectionName = payload.value
    //   postCollectionsMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    // },
    setSSCollectionsByKey(state, payload) {
      state.sectionsData[payload.sDomId].data[payload.key] = payload.value
      postCollectionsMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    // setSSCollectionsItems(state, payload) {
    //   state.sectionsData[payload.sDomId].data.items = payload.value
    //   postCollectionsMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    // },
    setSSCollectionsDelItem(state, payload) {
      state.sectionsData[payload.sDomId].data.items.splice(payload.index, 1)
      postCollectionsMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    setSSCollectionsAddItem(state, payload) {
      state.sectionsData[payload.sDomId].data.items.push(payload.value)
      postCollectionsMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    // setSSCollectionsRowsNum(state, payload) {
    //   state.sectionsData[payload.sDomId].data.oneRowsNum = payload.value
    //   postCollectionsMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    // },
    // --------- featured-collection section ---------
    setSFeaturedCollectionByKey(state, payload) {
      state.sectionsData[payload.sDomId].data[payload.key] = payload.value
      postFeaturedCollectionMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    // setSFeaturedCollectionId(state, payload) {
    //   state.sectionsData[payload.sDomId].data.collectionId = payload.value
    //   postFeaturedCollectionMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    // },
    // setSFeaturedCollectionName(state, payload) {
    //   state.sectionsData[payload.sDomId].data.collectionName = payload.value
    //   postFeaturedCollectionMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    // },
    // setSFeaturedCollectionTittle(state, payload) {
    //   state.sectionsData[payload.sDomId].data.title = payload.value
    //   postFeaturedCollectionMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    // },
    // setSFeaturedCollectionTittlePosition(state, payload) {
    //   state.sectionsData[payload.sDomId].data.titlePosition = payload.value
    //   postFeaturedCollectionMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    // },
    // setSFeaturedCollectionRowsNum(state, payload) {
    //   state.sectionsData[payload.sDomId].data.oneRowsNum = payload.value
    //   postFeaturedCollectionMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    // },
    // --------- footer section ---------
    setSFooterByKey(state, payload) {
      state.sectionsData[payload.sDomId].data[payload.key] = payload.value
      postSiteMapsMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    setSFooterSocialLinksByKey(state, payload) {
      state.sectionsData[payload.sDomId].data.socialLinks[`${payload.key}.url`] = payload.value
      postSiteMapsMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    // setSFooterShowPayIcon(state, payload) {
    //   state.sectionsData[payload.sDomId].data.showPayIcon = payload.value
    //   postSiteMapsMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    // },
    setSFooterMenuId(state, payload) {
      state.sectionsData[payload.sDomId].data.menus[payload.index].menuId = payload.value
      postSiteMapsMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    // setSFooterMenuShowTitle(state, payload) {
    //   state.sectionsData[payload.sDomId].data.menuExt[payload.index].showTitle = payload.value
    //   postSiteMapsMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    // },
    setSFooterEmailTitle(state, payload) {
      state.sectionsData[payload.sDomId].data.menus[payload.index]['title'] = payload.value
      postSiteMapsMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    setSFooterEmailShowTitle(state, payload) {
      state.sectionsData[payload.sDomId].data.menus[payload.index]['showTitle'] = payload.value
      postSiteMapsMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    setSFooterEmailMain(state, payload) {
      state.sectionsData[payload.sDomId].data.menus[payload.index]['main'] = payload.value
      postSiteMapsMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    // setSFooterFbLinks(state, payload) {
    //   state.sectionsData[payload.sDomId].data.socialLinks.facebook.url = payload.value
    //   postSiteMapsMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    // },
    // setSFooterItems(state, payload) {
    //   state.sectionsData[payload.sDomId].data.menus = payload.value
    //   postSiteMapsMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    // },
    setSFooterWidth(state, payload) {
      state.sectionsData[payload.sDomId].data.menus[payload.index].width = payload.value
      postSiteMapsMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    delSFooterItem(state, payload) {
      state.sectionsData[payload.sDomId].data.menus.splice(payload.index, 1)
      postSiteMapsMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    addSFooterItem(state, payload) {
      state.sectionsData[payload.sDomId].data.menus.push(payload.value)
      postSiteMapsMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    // ------------------ ins精选集-------------------------
    setInsByKey(state, payload) {
      state.sectionsData[payload.sDomId].data[payload.key] = payload.value
      postMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    setInsCardsByKey(state, payload) {
      state.sectionsData[payload.sDomId].data.cards[payload.index][payload.key] = payload.value
      postMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    setSInsCards(state, payload) {
      state.sectionsData[payload.sDomId].data.cards = payload.value
      postMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    delSInsCard(state, payload) {
      state.sectionsData[payload.sDomId].data.cards.splice(payload.index, 1)
      postMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    addSInsCard(state, payload) {
      let defaultItem = {
        id: Date.now(),
        imgUrl: '',
        imgAlt: '',
        actionUrl: '',
        profilePhoto: '',
        profilePhotoAlt: '',
        userName: '',
        accountId: ''
      }
      state.sectionsData[payload.sDomId].data.cards.push(defaultItem)
      postMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    // -------------------------图文-------------------------
    setImageTextByKey(state, payload) {
      state.sectionsData[payload.sDomId].data[payload.key] = payload.value
      postMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    // -------------------------图集（3图）-------------------------
    setThreeImageByKey(state, payload) {
      state.sectionsData[payload.sDomId].data[payload.key] = payload.value
      postMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    setThreeImageByIndexKey(state, payload) {
      state.sectionsData[payload.sDomId].data[`image${payload.index + 1}`][payload.key] = payload.value
      postMessage(state.IFRAME, state.sectionsData[payload.sDomId])
    },
    // ------------------ basicConfig 基础配置-------------------------
    setBasicConfigByKey(state, payload) {
      state.basicConfig[payload.key] = payload.value
    },
    // setBasicConfigFavi(state, payload) {
    //   state.basicConfig.favicon = payload.value
    // },
    // setBasicConfigFaviAlt(state, payload) {
    //   state.basicConfig.faviconAlt = payload.value
    // },
    // setBasicConfigLogo(state, payload) { // 基础配置的logo与sectionData里面的保持一致
    //   state.basicConfig.logoUrl = payload.value
    // },
    // setBasicConfigLogoAlt(state, payload) { // 基础配置的logo与sectionData里面的保持一致
    //   state.basicConfig.logoAlt = payload.value
    // },
    // ------ basicConfig color -------
    // setBasicConfigColorPageBg(state, payload) {
    //   state.basicConfig.color.pageBg = payload.value
    //   postMessage(state.IFRAME, {...state.basicConfig.color, changeColor: true})
    // },
    // setBasicConfigColorHeaderBg(state, payload) {
    //   state.basicConfig.color.headerBg = payload.value
    //   postMessage(state.IFRAME, {...state.basicConfig.color, changeColor: true})
    // },
    // setBasicConfigColorHeaderColor(state, payload) {
    //   state.basicConfig.color.headerColor = payload.value
    //   postMessage(state.IFRAME, {...state.basicConfig.color, changeColor: true})
    // },
    // setBasicConfigColorNoticeBg(state, payload) {
    //   state.basicConfig.color.noticeBg = payload.value
    //   postMessage(state.IFRAME, {...state.basicConfig.color, changeColor: true})
    // },
    // setBasicConfigColorNoticeColor(state, payload) {
    //   state.basicConfig.color.noticeColor = payload.value
    //   postMessage(state.IFRAME, {...state.basicConfig.color, changeColor: true})
    // },
    setBasicConfigColorReset(state, payload) {
      state.basicConfig.color = payload.value
      postMessage(state.IFRAME, {...state.basicConfig.color, changeColor: true})
    },
    setBasicConfigColor(state, payload) {
      state.basicConfig.color = {...state.basicConfig.color, ...payload}
      postMessage(state.IFRAME, {...state.basicConfig.color, changeColor: true})
    },
    setBasicConfigBase(state, payload) {
      state.basicConfig.base = {...state.basicConfig.base, ...payload}
      postMessage(state.IFRAME, {...state.basicConfig.base})
    },
    // ------------------ site map-------------------------
    setSiteMaps(state, payload) {
      state.siteMaps = payload.value
    }
  },
}
